import React, { useState } from "react";

import Button from "react-bootstrap/Button";

import Modal from "react-bootstrap/Modal";

import ImageThumb from "../../../component/imageThumb";

function ProfileDetail(props) {
  const [lgShow, setLgShow] = useState(false);

  const item = props?.location?.state?.item;

  const business = item?.business_details;

  const bank = item?.bank_detail;

  return (
    <div>
      <Button
        style={{ fontSize: 14 }}
        variant="link"
        onClick={() => setLgShow(true)}
      >
        View Profile Detail
      </Button>

      <Modal
        size="lg"
        show={lgShow}
        onHide={() => setLgShow(false)}
        aria-labelledby="example-modal-sizes-title-lg"
      >
        <Modal.Header closeButton className="py-1">
          <Modal.Title id="example-modal-sizes-title-sm">
            Seller Profile Detail
          </Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <div className="row">
            {/* ================= BUSINESS DETAILS ================= */}
            <div className="col-md-12">
              <h5
                className="mb-0 text-dark"
                style={{
                  fontWeight: "700",
                  fontSize: 14,
                  textTransform: "uppercase",
                }}
              >
                Business Detail
              </h5>
              <hr className="mt-0" />

              <div className="address-box mb-3">
                <h6 className="mb-1">{business?.business_name || "N/A"}</h6>

                <p className="mb-1">{business?.address || "N/A"}</p>

                <div className="d-flex flex-wrap">
                  <p className="mb-2" style={{ width: "33.3%" }}>
                    <strong>State :</strong> <br />
                    {business?.stateName || "N/A"}
                  </p>

                  <p className="mb-2" style={{ width: "33.3%" }}>
                    <strong>City :</strong> <br />
                    {business?.cityName || "N/A"}
                  </p>

                  <p className="mb-2" style={{ width: "33.3%" }}>
                    <strong>District :</strong> <br />
                    {business?.districtName || "N/A"}
                  </p>

                  <p className="mb-2" style={{ width: "33.3%" }}>
                    <strong>PIN Code :</strong> <br />
                    {business?.pin || "N/A"}
                  </p>

                  <p className="mb-2" style={{ width: "33.3%" }}>
                    <strong>Mobile :</strong> <br />
                    {business?.mobile || "N/A"}
                  </p>

                  <p className="mb-2" style={{ width: "33.3%" }}>
                    <strong>Alt Mobile :</strong> <br />
                    {business?.alt_mobile || "N/A"}
                  </p>

                  <p className="mb-2" style={{ width: "33.3%" }}>
                    <strong>Email :</strong> <br />
                    {business?.business_email || "N/A"}
                  </p>

                  <p className="mb-2" style={{ width: "33.3%" }}>
                    <strong>Business Type :</strong> <br />
                    {business?.business_category_name || "N/A"}
                  </p>

                  <p className="mb-2" style={{ width: "100%" }}>
                    <strong>Description :</strong> <br />
                    {business?.business_description || "N/A"}
                  </p>
                </div>

                <div className="d-flex flex-wrap mt-3">
                  <p className="mb-2" style={{ width: "33.3%" }}>
                    <strong>Trade License :</strong> <br />
                    {item?.trade_lic_no || "N/A"} <br />
                    <ImageThumb image={item?.trade_lic_image} />
                  </p>

                  <p className="mb-2" style={{ width: "33.3%" }}>
                    <strong>PAN No :</strong> <br />
                    {item?.pan || "N/A"} <br />
                    <ImageThumb image={item?.pan_image} />
                  </p>

                  <p className="mb-2" style={{ width: "33.3%" }}>
                    <strong>GST No :</strong> <br />
                    {item?.gst || "N/A"} <br />
                    <ImageThumb image={item?.gst_image} />
                  </p>
                </div>
              </div>
            </div>

            {/* ================= BANK DETAILS ================= */}
            <div className="col-md-12">
              <h5
                className="mb-0 text-dark"
                style={{
                  fontWeight: "700",
                  fontSize: 14,
                  textTransform: "uppercase",
                }}
              >
                Bank Detail
              </h5>
              <hr className="mt-0" />

              <div className="address-box mb-3">
                <div className="d-flex flex-wrap">
                  <p className="mb-2" style={{ width: "33.3%" }}>
                    <strong>A/c Holder Name :</strong> <br />
                    {bank?.name || "N/A"}
                  </p>

                  <p className="mb-2" style={{ width: "33.3%" }}>
                    <strong>A/c No :</strong> <br />
                    {bank?.ac_no || "N/A"}
                  </p>

                  <p className="mb-2" style={{ width: "33.3%" }}>
                    <strong>IFSC :</strong> <br />
                    {bank?.ifsc || "N/A"}
                  </p>

                  <p className="mb-2" style={{ width: "33.3%" }}>
                    <strong>Bank Name :</strong> <br />
                    {bank?.bank_name || "N/A"}
                  </p>

                  <p className="mb-2" style={{ width: "33.3%" }}>
                    <strong>Bank Branch :</strong> <br />
                    {bank?.branch || "N/A"}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </div>
  );
}

export default ProfileDetail;
